import app from "./app.js";
import { BsgEmpty } from "./BsgEmpty.js";
import { BsgFooter } from "./BsgFooter.js";
import { BsgHeader } from "./BsgHeader.js";
import { BsgIdOwnsNotice } from "./BsgIdOwnsNotice.js";

export default app;
export { app as bsgChromeApp, BsgEmpty, BsgFooter, BsgHeader, BsgIdOwnsNotice };